import { render } from "./News03.vue?vue&type=template&id=08b9a96a&scoped=true"
import script from "./News03.vue?vue&type=script&lang=js"
export * from "./News03.vue?vue&type=script&lang=js"

import "./News03.vue?vue&type=style&index=0&id=08b9a96a&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b9a96a"]])

export default __exports__